import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './utils/context';
import { AuthProvider } from './utils/AuthProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter as Router } from 'react-router-dom'; // Router import

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router> {/* Router wrapped here */}
      <ThemeProvider>
        <AuthProvider>
          <GoogleOAuthProvider clientId="285383883957-dkp2fsji75gb54ej86r9ui4s0h4cg9te.apps.googleusercontent.com">
            <App />
          </GoogleOAuthProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  </React.StrictMode>
);